module.exports = __webpack_public_path__ + "img/catseye01.4231fd3f.jpg";